module.exports = __webpack_public_path__ + "static/media/life_pro_tips_book_cover_792x1024.3d6ed1d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/life_pro_tips_book_cover_792x1024.png
// module id = 236
// module chunks = 0